// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2gUGv","infoBtn":"quickbooks_infoBtn__3qh6N","formBox":"quickbooks_formBox__2C4qO","formFooter":"quickbooks_formFooter__37qvf"};